<template>
  <div class="transcribe-tab" :style="{ height: tabHeight }">
    <TranscribeSDK :conversationId="conversationId" />
  </div>
</template>

<script>
import TranscribeSDK from "./TranscribeSDK";
export default {
  name: "TranscribeTab",
  components: { TranscribeSDK },
  props: {
    tabHeight: {
      type: String,
      default: "100%",
    },
    conversationId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.transcribe-tab {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    overflow-y: auto;
    border-top: none !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
}
</style>
